import React, { useState } from 'react';
import { Alert, Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

function CancelAction({ type, cancelEventItem }) {
  const [show, setShow] = useState(false);
  const handleShow = (e) => { e.preventDefault(); setShow(true); }
  const handleClose = (e) => { setShow(false); }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Remove</Tooltip>}
    >

      <button
        title="Remove"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="far fa-trash-alt"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Remove {type}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant='primary'>
          Are you sure you want to remove this {type.toLowerCase()}?
        </Alert>

      </Modal.Body>

      <Modal.Footer>
        <Button onClick={() => {
          handleClose();
          cancelEventItem()
        }} variant="primary">Yes</Button>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default CancelAction;